import { Box, Divider, Typography ,styled} from "@mui/material";
import { Link } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";

const CustomeColor = styled(Box)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
  height: "230px",
  padding: "10px",
  marginTop: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
}));
const Footer = () => {
  return (
    <CustomeColor>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Typography
          component={Link}
          to={"/aboutus"}
          variant="body2"
          sx={{ textDecoration: "none", color: "white" }}
        >
          About Us
        </Typography>
        <Typography
          component={Link}
          to={"/contactus"}
          variant="body2"
          sx={{ textDecoration: "none", color: "white" }}
        >
          Contact Us
        </Typography>
        <Typography
          component={Link}
          to={"/aboutus"}
          variant="body2"
          sx={{ textDecoration: "none", color: "white" }}
        >
          Site Map
        </Typography>
      </Box>
      <Divider variant="fullwidth" sx={{ color: "white" }} />

      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          alignItems: "center",
          color:'white'
        }}
      >
        <Box>
          <Typography variant="body1" textAlign={"center"}>
            {" "}
            Follow Us
          </Typography>
          <Box>
            <InstagramIcon
              fontSize="1.5rem"
              sx={{ width: "2rem", height: "2rem" }}
            />
            <InstagramIcon
              fontSize="1.5rem"
              sx={{ width: "2rem", height: "2rem" }}
            />
            <InstagramIcon
              fontSize="1.5rem"
              sx={{ width: "2rem", height: "2rem" }}
            />
          </Box>
        </Box>
        <Box display={"flex"} sx={{ flexWrap: "wrap", gap: "5px" }}>
          <Typography variant="body1">Home</Typography>
          <Divider
            orientation="vertical"
            variant="fullwidth"
            flexItem
            sx={{ borderColor: "white" }}
          />
          <Typography variant="body1">Brands</Typography>
          <Divider
            orientation="vertical"
            variant="fullwidth"
            flexItem
            sx={{ borderColor: "white" }}
          />
          <Typography variant="body1">Categories</Typography>
        </Box>
      </Box>

      <Box sx={{ alignSelf: "center" ,color:'white' }}>
        <Typography variant="body2">@ Copyrigth 2025 CosmetixHub</Typography>
      </Box>
      <Box sx={{ alignSelf: "center" ,color:'white' }}>
        <Typography variant="body2">
          Privacy Policy - Terms & Condition
        </Typography>
      </Box>
    </CustomeColor>
  );
};

export default Footer;
